import { render, staticRenderFns } from "./OrdersDispatchesTally.vue?vue&type=template&id=ca81b742&scoped=true"
import script from "./OrdersDispatchesTally.vue?vue&type=script&lang=ts"
export * from "./OrdersDispatchesTally.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca81b742",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca81b742')) {
      api.createRecord('ca81b742', component.options)
    } else {
      api.reload('ca81b742', component.options)
    }
    module.hot.accept("./OrdersDispatchesTally.vue?vue&type=template&id=ca81b742&scoped=true", function () {
      api.rerender('ca81b742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders-dispatches/components/OrdersDispatchesTally.vue"
export default component.exports